import'@firebase/remote-config';